export default __webpack_public_path__ + "84ef9c53c51edca7f32b594fccc7c8c2.png";